import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import {
  CardNumberSortEnum,
  EventDateSortEnum,
  OwnerSortEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';
import { Messages } from 'core/global.types';
import { Table } from 'ui/table/Table';
import { SortBy } from 'ui/table/headerSortItem/HeaderSortItem.types';

import { InneEventsTableHeaderProps } from './InneEventsTableHeader.types';

export const InneEventsTableHeader = ({ displayFullTable }: InneEventsTableHeaderProps) => {
  const { formatMessage } = useLocale();

  const createSortableElement = (sortBy: SortBy, headerTitle: Messages) => (
    <Table.HeaderSortItem
      queryKey={QueryKeyLocalStorageEnum.EVENTS_OTHER}
      sortBy={sortBy}
      queryHeader={formatMessage({ id: AppMessages[headerTitle] })}
    />
  );

  return (
    <>
      <Table.HeaderItem>{formatMessage({ id: AppMessages['events.other.header.id'] })}</Table.HeaderItem>

      {createSortableElement(CardNumberSortEnum, 'events.other.header.card')}

      <Table.HeaderItem>{formatMessage({ id: AppMessages['events.other.header.category'] })}</Table.HeaderItem>

      {displayFullTable && createSortableElement(OwnerSortEnum, 'events.other.header.owner')}

      <Table.HeaderItem>{formatMessage({ id: AppMessages['events.other.header.mod'] })}</Table.HeaderItem>

      <Table.HeaderItem>{formatMessage({ id: AppMessages['events.other.header.mode'] })}</Table.HeaderItem>

      {createSortableElement(EventDateSortEnum, 'events.other.header.date')}
    </>
  );
};
